import { createSelector, createSlice } from '@reduxjs/toolkit'

const sliceName = 'ada_chat'

const initialState = {
  isChatOpen: false,
  isChatActive: false
}
const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setChatOpenState: (state) => {
      state.isChatOpen = true
    },
    setChatClosedState: (state) => {
      state.isChatOpen = false
    },
    setChatActiveState: (state) => {
      state.isChatActive = true
    },
    setChatInactiveState: (state) => {
      state.isChatActive = false
    }
  }
})

export const { reducer, actions: {
  setChatOpenState,
  setChatClosedState,
  setChatActiveState,
  setChatInactiveState
} } = slice

const rootSelector = (state) => state[sliceName]

export const isChatOpenSelector = createSelector(rootSelector, ({ isChatOpen }) => isChatOpen)

export const isChatActiveSelector = createSelector(rootSelector, ({ isChatActive }) => isChatActive)
